import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-b', 'LetterB', [["path",{"d":"M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"}],["path",{"d":"M7 12l6 0"}]]);